module.exports = __webpack_public_path__ + "static/media/WBTCeth.7c448f4b.svg";